namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_quick, {
		
		background: {
			color: $mol_theme.back,
		},
		
		boxShadow: '0 0 1rem hsla(0,0%,0%,.5)',
		// boxShadow: '0 -0.5rem 0.5rem -0.5rem hsla(0,0%,0%,0.25),0 0.5rem 0.5rem -0.5rem hsla(0,0%,0%,0.25)',
		// padding: '1px',
		// outline: 'solid 1px var(--mol_theme_line)',
		border: {
			radius: $mol_gap.round,
		},
		position: 'relative',
		height: '2.5rem',

		Panel: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			pointerEvents: 'auto',
			// gap: '1px',
			// gap: $mol_gap.space,
			// outline: 'solid 1px var(--mol_theme_line)',
		},

		Speck: {
			padding: 0,
			position: 'absolute',
			left: '0.3rem',
			top: '-0.2rem',
			// margin: {
			// 	top: '-0.2rem',
			// },
			background: {
				color: 'transparent',
			},
			font: {
				size: '12px',
			},
		},

		Button: {
			background: {
				color: $mol_theme.card,
			},
			boxShadow: 'inset 0 0 0 1px var(--mol_theme_field)',
			justify: {
				content: 'center',
			},
			font: {
				size: '20px',
			},
			width: '3rem',
			'[mol_check_checked]': {
				true: {
					outline: '2px solid var(--mol_theme_current) !important',
				},
			},
		},

		Remove_area: {
			border: {
				radius: $mol_gap.round,
			},
			position: 'absolute',
			right: '-200px',
			width: '100px',
			color: '#ff6666',
			backgroundColor: 'hsla(0, 100%, 70%, 0.1)',
			height: '100%',
			align: {
				items: 'center',
			},
			justify: {
				content: 'center',
			},
			outline: '2px dashed hsla(0, 100%, 70%, 0.5)',
			'[remove_area_active]': {
				true: {
					opacity: 1,
					outline: '2px solid hsla(0, 100%, 70%, 0.5)',
					backgroundColor: 'hsla(0, 100%, 70%, 0.4)',
				},
			},
			pointerEvents: 'none',
		},

		Hovered_title: {
			background: {
				color: $mol_theme.back,
			},
			position: 'absolute',
			left: '50%',
			top: '-2rem',
			transform: 'translateX(-50%)',
			whiteSpace: 'nowrap',
		},
		
	} )
	
}
